import { Popup } from "react-map-gl";
import { Marker } from "react-map-gl";
import { Pin } from "../api";
import { IconButton, Typography } from "@mui/material";
import { Box } from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import { useState } from "react";
import { Delete } from "@mui/icons-material";

interface PinMarkerProps {
  pin: Pin;
  deletePin: (pinId: string) => void;
}

export const PinMarker = ({ pin, deletePin }: PinMarkerProps) => {

  const [hovered, setHovered] = useState(false);

  const handleDelete = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    e.stopPropagation();
    deletePin(pin.id);
  };

  return (
    <Marker longitude={pin.center[0]} latitude={pin.center[1]}>
      <Box
        sx={{
          backgroundColor: "white",
          borderRadius: "5px",
          opacity: 0.8,
        }}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
      >
        <Box display="flex" alignItems="center" sx={{ gap: 1 }}>
          <HomeIcon />
          <Typography>{pin.label}</Typography>
          {hovered && (
            <IconButton
              color="error"
              onClick={handleDelete}
            >
              <Delete />
            </IconButton>
          )}
        </Box>
      </Box>
    </Marker>
  );
};